import Image from "next/image";
import React from "react";
import CardSupport from "./cardSupport";

export default function SuuportSection() {
  return (
    <section
      id="Aplikasi-Pendukung"
      className="flex flex-col mt-10 scroll-mt-28"
    >
      <h3 className="text-primary-800 text-2xl font-semibold mb-3">
        Aplikasi Pendukung
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4">
        <Image
          src={"/assets/images/support.png"}
          width={900}
          height={900}
          alt="support-office"
          className="row-span-2"
        />
        <CardSupport
          href="https://simreses.dprd.palikab.go.id"
          title="Aplikasi SIM ERESES"
          desc="Platform digital untuk masyarakat mengajukan aspirasi, mengelola, memantau, dan menindaklanjuti aspirasi yang dijadikan dasar dalam perencanaan pembangunan daerah"
        />
        <CardSupport
          title="SIM SEKWAN"
          href="/"
          desc="Platform digital terintegrasi yang mendukung seluruh proses administrasi - pencatatan, monitoring, hingga pengarsipan - serta meningkatkan produktivitas, akurasi, dan transparansi dalam pengelolaan dokumen dan korespondensi instansi."
        />
      </div>
    </section>
  );
}
